/** Коды типов заявок (application_type.code) */
export const APPLICATION_TYPE_CODE = {
  GOV_QUEUE: 'GOV_QUEUE',
  GOV_SHORT_QUEUE: 'GOV_SHORT_QUEUE',
} as const;

/** id типов заявок — fallback, когда в данных нет кода */
const GOV_QUEUE_ID = 1;
const GOV_SHORT_QUEUE_ID = 2;

/**
 * Гос очередь или краткосрочная (гос) очередь.
 * Для таких заявок блок «Очередь в группу» не показывается.
 */
export const isGovOrShortApplication = (
  code?: string | null,
  idApplicationType?: number | string | null
): boolean => {
  if (code) {
    return (
      code === APPLICATION_TYPE_CODE.GOV_QUEUE || code === APPLICATION_TYPE_CODE.GOV_SHORT_QUEUE
    );
  }

  const id = Number(idApplicationType);

  return id === GOV_QUEUE_ID || id === GOV_SHORT_QUEUE_ID;
};
